import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "font-awesome/css/font-awesome.min.css";
import {
  Row,
  Col,
  Button,
  Card,
  Form,
  Image,
  Alert,
  Container,
} from "react-bootstrap";
import NumberFormat from "react-number-format";
import {
  selectFilters,
  selectPreferedPriceDisplayFormat,
} from "./showPrices.selectors";
import {
  selectTier,
  TIERS,
  CLASS,
  setShouldShowRFQDetails,
  selectPrice,
  selectUtilities,
  savePrice,
  getApplicableMargin,
  selectAllProducts,
  COMMODITY,
  selectSuppliersLogo,
  getSupplierLogo,
  setIsPriceExpired,
  getRateCodes,
  setIsSupplierUpdated,
  selectUserSettings,
  getStateFromZip,
} from "../GetPrice";
import BusyIndicator, { REGIONS } from "../../widgets/busyIndicator";
import ShowPriceDetails from "./ShowPriceDetails";
import { actions } from "./showPrices.slice";
import { getMonth, getMonths, getYears } from "./showPrices.utils";
import {
  ALL_PRODUCT,
  DEFALUT_NO_SUPPLIER_LOADED_MESSAGE,
  LOAD_PROFILE,
  SELECT_SUPPLIERS,
  SORTING_ORDERS,
} from "./showPrice.constants";
import Overlay from "../../widgets/Tooltip";
import {
  setSelectedSupplier,
  selectSteps,
  setSteps,
  unit,
  getUSStates,
  selectUSStates,
  ENEREX_STATES,
  ENEREX_STATESFORPRICE,
  resetCustomerAccountsInfo,
  getAcountPattern,
} from "../PriceAndCustomerDetails";
import ShowMoreFilters from "./ShowMoreFilters";
import classNames from "classnames";
import handleCloseWidget from "../../helper/handleCloseWidget";
import {
  selectSearchedPrices,
  selectSearchedPricesUtility,
  selectSearchedPricesSuppliers,
  selectServiceTeritorry,
  selectServiceTeritorryStates,
  selectServiceTeritorrySuppliers,
  selectServiceTeritorryUtilities,
  selectSearchedPricesMetadata,
  selectSelectedUtilities,
} from "../GetPrice/getPrice.selectors";
import { actions as getPricesAction } from "../GetPrice/getPrice.slice";
import {
  selectPortalSetting,
  COMMODITIES_LIST,
  getSearchPrice,
  selectRateCodes,
  selectIsPriceExpired,
  getSuppierAddressFields,
} from "../GetPrice";
import { selectClientConfig } from "../clientContext";
import { isEmpty } from "lodash";
import {
  supplierFields,
  brokerageIdsForTermRange,
} from "./showPrice.constants";
import queryString from "query-string";
import { getFormattedPrice } from "../../helper/getFormattedPrice";
import {
  getMonthlyUsage,
  getUsage,
  getTermFilteredPlans,
} from "../../helper/getUsage";
import analytics from "../../helper/analytics";
import { monthNames } from ".";
import { useUserContext } from "../utils/userContext";
import { ALL_SUPPLIERS } from "./showPrice.constants";
import { ContactMeButton } from "../ContactMeView/ContactMeButton";
import { showESIIDorECLID } from "../PriceAndCustomerDetails/priceAndCustomerDeatils.helpers";

const {
  setPriceForComparision,
  setSupplierPricesTriggeredFromGetPrices,
  setSelectedUtilities,
} = getPricesAction;
const { setFilters, setPreferedPriceDisplayFormat } = actions;
const emptyArray = [];
const emptyString = "";
const { ELECTRIC, NAT_GAS } = unit;
const FIRST = 0;

const ShowPrices = () => {
  const ctx = useUserContext();
  const history = useHistory();
  const dispatch = useDispatch();
  const basicInfo = useSelector(selectPrice);
  const userSettings = useSelector(selectUserSettings);
  const filters = useSelector(selectFilters);
  const tier = useSelector(selectTier);
  const rateCodes = useSelector(selectRateCodes);
  let searchedPrices = useSelector(selectSearchedPrices);
  const initialSupplierData = useSelector(selectSearchedPrices);
  const residentialUtilities = useSelector(selectSearchedPricesUtility);
  const products = useSelector(selectAllProducts);
  const USStates = useSelector(selectUSStates);
  const loadZoneRateCodes = rateCodes.map((each) => each.LoadProfile);
  const rateClassCodes = rateCodes.map((each) => each.RateClass);
  const isPriceExpired = useSelector(selectIsPriceExpired);
  const commercialUtilities = useSelector(selectUtilities);
  const serviceTeritorry = useSelector(selectServiceTeritorry);
  const serviceTeritorryStates = useSelector(selectServiceTeritorryStates);
  const serviceTeritorrySuppliers = useSelector(
    selectServiceTeritorrySuppliers
  );
  const serviceTeritorryUtilities = useSelector(
    selectServiceTeritorryUtilities
  );
  const searchedPricesMetaData = useSelector(selectSearchedPricesMetadata);
  const selectedUtilities = useSelector(selectSelectedUtilities);
  const suppliersToBeCompared = searchedPrices.filter(
    (supplier) => supplier.isSelectedForPriceComparision === true
  );
  const searchedPricesSuppliers = useSelector(selectSearchedPricesSuppliers);
  const [localZipCode, setLocalZipCode] = useState(basicInfo.zipCode);
  const [productType, setProductType] = useState(ALL_PRODUCT);
  const [isOnePriceSelected, setIsOnePriceSelected] = useState(false);
  const [showUtilityError, setShowUtilityError] = useState(false);
  const [cardDetails, setCardDetails] = useState(false);
  const [chosenAccordian, setChosenAccordian] = useState([]);
  const [info, setInfo] = useState({
    class: filters?.class || basicInfo.class,
    commodity: filters?.commodity || basicInfo.commodity,
  });
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; 
const currentDay = currentDate.getDate();
  const [sorted, setSorted] = useState(true);
  const utilities =
    info.class === CLASS.COMMERCIAL
      ? commercialUtilities
      : residentialUtilities;
  const currentMonthAndYear = getMonth();
  const evaluateSupplierPlaceholder = () => {
    switch (true) {
      case selectedSuppliers.length === 1:
        return (
          <option disabled value={SELECT_SUPPLIERS}>
            {selectedSuppliers[0]}
          </option>
        );
      case selectedSuppliers.length > 1:
        return (
          <option
            disabled
            value={SELECT_SUPPLIERS}
          >{`${selectedSuppliers.length} suppliers selected`}</option>
        );
      case selectedSuppliers.length === 0:
      default:
        return (
          <option disabled value={SELECT_SUPPLIERS}>
            Select Suppliers
          </option>
        );
    }
  };
  // Filteration method for the searched Prices
  const getServiceTeritorryTermFilteredPlans = (searchedPrices) => {
    // Add filteration on terms
    //check State
    //check Utility
    // Check Supplier
    const statePresent = serviceTeritorryStates.includes(
      basicInfo?.state?.displayName
    );
    const utilitiesPresent = serviceTeritorryUtilities.filter((i) =>
      residentialUtilities.map((i) => i.LDCId).includes(i)
    );
    const suppliersPresent = serviceTeritorrySuppliers.filter((i) =>
      searchedPricesMetaData.Suppliers.map((i) => i.SupplierId).includes(i)
    );
    if (
      !statePresent ||
      utilitiesPresent.length == 0 ||
      suppliersPresent.length == 0
    )
      return searchedPrices;
    // Start Filteration
    // Filter Service Territorry data
    let filteredServiceTerritorry = [];
    //BASED ON STATES
    filteredServiceTerritorry = serviceTeritorry.data.filter(
      (i) => i.State[0] === basicInfo?.state?.displayName
    );
    //BASED ON SUPPLIER
    filteredServiceTerritorry = filteredServiceTerritorry.filter((i) => {
      let res = suppliersPresent.some((x) => {
        let suppIds = [
          ...i.SupplierInfo.map((j) => j.SupplierIdentifier.toLowerCase()),
        ];
        return suppIds.includes(x.toLowerCase());
      });
      return res;
    });
    //BASED ON UTILITIES
    filteredServiceTerritorry = filteredServiceTerritorry.filter((i) => {
      let res = utilitiesPresent.some((x) => {
        let UtIds = [
          ...i.UtilityInfo.map((j) => j.UtilityIdentifier.toLowerCase()),
        ];
        return UtIds.includes(x.toLowerCase());
      });
      return res;
    });
    //Filter prices
    let filteredSearchedPrices = [];
    const findTerm = (supp, ut) => {
      return filteredServiceTerritorry.find((x) => {
        return (
          x.SupplierInfo.map((i) =>
            i.SupplierIdentifier.toLowerCase()
          ).includes(supp.toLowerCase()) &&
          x.UtilityInfo.map((i) => i.UtilityIdentifier.toLowerCase()).includes(
            ut.toLowerCase()
          )
        );
      });
    };

    filteredSearchedPrices = searchedPrices.filter((price) => {
      if (
        !utilitiesPresent.includes(price.LDCId) &&
        !suppliersPresent.includes(price.SupplierId)
      )
        return true;
      if (!findTerm(price.SupplierId, price.LDCId)) return true;
      const term = findTerm(price.SupplierId, price.LDCId).Term;
      const minTerm = term.split("-")[0];
      const maxTerm = term.split("-")[1];
      if (parseInt(minTerm) <= price.Term && price.Term <= parseInt(maxTerm)) {
        return true;
      }
      return false;
    });
    return filteredSearchedPrices;
  };
  const getEndDateMonth = () => {
    const endDate = new Date(userSettings.endDate);
    const month = endDate ? endDate.getMonth() : "";
    const index = month === 11 ? 0 : month + 1;
    return monthNames[index];
  };
  const getEndDateYear = () => {
    const endDate = new Date(userSettings.endDate);
    const month = endDate ? endDate.getMonth() : "";
    const year = endDate ? endDate.getFullYear() : "";
    return month === 11 ? year + 1 : year;
  };
  const [filterInfo, setFilterInfo] = useState({
    month:
      (!isEmpty(userSettings) ? getEndDateMonth() : filters?.month) ||
      currentMonthAndYear.month,
    year:
      (!isEmpty(userSettings) ? getEndDateYear() : filters?.year) ||
      currentMonthAndYear.year,
    product: filters?.product || "all_products",
    utility: filters?.utility || basicInfo?.utility || [],
    sort: filters?.sort || "Price",
    order: filters?.order || "ASC",
    supplier: filters?.supplier || "all_suppliers",
    from: filters?.from || emptyString,
    to: filters?.to || emptyString,
    zipCode: filters?.zipCode || localZipCode,
    class: filters?.class || info.class,
    commodity: filters?.commodity || info.commodity,
    Suppliers: filters?.Suppliers || [],
    rateClass: basicInfo?.rateCode || "",
    usage: basicInfo?.usage || "",
  });
  const steps = useSelector(selectSteps);
  const [updatedStepsForFalseEnrollment, setUpdatedStepsForFalseEnrollment] =
    useState(emptyArray);
  const [stepsForEnrollmentandPlanId, setStepsForEnrollmentandPlanId] =
    useState(emptyArray);
  const [show, setShow] = useState(true);
  const portalSettings = useSelector(selectPortalSetting);

  const selectedUtility =
    filters.utility &&
    residentialUtilities.find(
      (each) => each.LDCName === filters.utility.LDCName
    );
  const { messageOnEmptyResult } = portalSettings; // Need to update once we know the key name
  const clientConfig = useSelector(selectClientConfig);
  const { brokerageId, isFullScreen, authKey, domainTerm, client } =
    clientConfig;
  const MARGIN = "Margin";
  const suppliersLogo = useSelector(selectSuppliersLogo);
  const [showPriceExpiredAlert, setShowPriceExpiredAlert] = useState(true);
  const [updateOnBlur, setUpdateOnBlur] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState(
    filters?.Suppliers?.length > 0
      ? filters.Suppliers.map(
          (filteredSupp) =>
            searchedPricesSuppliers.find((i) =>
              Object.values(i).includes(filteredSupp)
            ).SupplierName ?? ""
        )
      : []
  );
  const { oid: opportunityId } = queryString.parse(window.location.search);
  const isEnerexStatePresent =
    basicInfo.state && ENEREX_STATES.includes(basicInfo.state.name);
  const isEnerexStatePresentForPrice =
    basicInfo.state && ENEREX_STATESFORPRICE.includes(basicInfo.state.name);
  const preferedPriceDisplayFormat = useSelector(
    selectPreferedPriceDisplayFormat
  );
  searchedPrices = getTermFilteredPlans(
    searchedPrices,
    brokerageId,
    brokerageIdsForTermRange
  );
  if (client && domainTerm !== "null") {
    searchedPrices = searchedPrices.filter((price) => {
      const minTerm = domainTerm.split("-")[0];
      const maxTerm = domainTerm.split("-")[1];
      if (parseInt(minTerm) <= price.Term && price.Term <= parseInt(maxTerm)) {
        return true;
      }
      return false;
    });
  } else if (
    searchedPrices.length > 0 &&
    Object.keys(searchedPricesMetaData).length > 0 &&
    basicInfo.state
  ) {
    searchedPrices = getServiceTeritorryTermFilteredPlans(searchedPrices);
  }
  useEffect(() => {
    setTimeout(() => {
      setShowPriceExpiredAlert(false);
    }, 20000);
  }, []);

  useEffect(() => {
    isEmpty(USStates) && dispatch(getUSStates());
  }, [dispatch, USStates]);

  useEffect(() => {
    dispatch(setShouldShowRFQDetails(false));
    dispatch(setSelectedSupplier());
  }, [dispatch]);

  useEffect(() => {
    if (filterInfo.isFilterUpdated || isEmpty(filters)) {
      dispatch(setFilters(filterInfo));
      setFilterInfo({ ...filterInfo, isFilterUpdated: false });
    }
  }, [dispatch, filterInfo, filters]);

  useEffect(() => {
    setUpdatedStepsForFalseEnrollment(
      steps.filter((step) => step.label !== "Enrollment")
    );
    setStepsForEnrollmentandPlanId(
      steps.filter((step) => step.label !== "Additional Information")
    );
  }, [steps]);

  useEffect(() => {
    const customLogoIds = [...new Set([...searchedPrices.filter(i => !!i.logo && i.logo.toLowerCase() !== i.SupplierId.toLowerCase()).map(i => {return i.logo})])].map(i => {return{SupplierId: i}});
    Promise.all(
      [...customLogoIds,...searchedPricesSuppliers].map(
        (each) =>
          !suppliersLogo[each.SupplierId] &&
          dispatch(getSupplierLogo(each.SupplierId))
      )
    );
  }, [searchedPricesSuppliers, suppliersLogo, dispatch]);
const monthNameToNumber = (name) => {
  return new Date(Date.parse(name + " 1, 2020")).getMonth() + 1;
};

  const selectedMonths = getMonths(userSettings.endDate);
 let monthsOptions = selectedMonths.filter(
  (each) => each.year === Number(filterInfo.year)
);
// If today’s date > 21, remove the current month
if (currentDay >= 21) {
  monthsOptions = monthsOptions.filter(
    (each) => monthNameToNumber(each.month) !== currentMonth
  );
}
  const selectedYears = getYears(userSettings.endDate);

  const getMonthFromString = (mon) => {
    const updatedMonth = new Date(Date.parse(mon + " 1, 2021")).getMonth() + 1;
    if (updatedMonth < 10) return "0" + updatedMonth;
    return updatedMonth;
  };

  const startDate =
    filters.year + "-" + getMonthFromString(filters.month) + "-01";

  const getLoadZone = (rateCode, loadZoneRateCodes = []) => {
    return rateCode === "All"
      ? loadZoneRateCodes
      : loadZoneRateCodes.includes(rateCode)
      ? [rateCode]
      : [loadZoneRateCodes[FIRST]];
  };

  useEffect(() => {
    if (filters.isFilterUpdated) {
      let formValues = {
        SortBy: filters.sort,
        SortDirection: filters.order,
        BrokerId: brokerageId,
        LDCS:
          filters.class === CLASS.RESIDENTIAL
            ? selectedUtility
              ? [selectedUtility.LDCId]
              : []
            : filterInfo.utility?.LDCIdentifier
            ? [filterInfo.utility.LDCIdentifier]
            : [],
        Commodity: COMMODITIES_LIST[filters.commodity],
        RateClassification: filters.class,
        Suppliers: filters.Suppliers,
        ZipCode: filters.zipCode,
        greenPercentage: filters.greenPercentage || "00",
        StartDate: startDate,
        UsageMin: filters.usage || getUsage(portalSettings.keyValue, basicInfo),
      };
      formValues = isEnerexStatePresent
        ? {
            ...formValues,
            LoadZone: getLoadZone(basicInfo.rateCode, loadZoneRateCodes),
          }
        : {
            ...formValues,
            RateClass:
              basicInfo.rateCode && basicInfo.rateCode === "All"
                ? rateClassCodes
                : [basicInfo.rateCode],
          };
      if (filters.from)
        formValues = { ...formValues, TermsMin: parseInt(filters.from) };
      if (filters.to)
        formValues = { ...formValues, TermsMax: parseInt(filters.to) };
      dispatch(getSearchPrice(formValues));
      dispatch(setFilters({ ...filters, isFilterUpdated: false }));
    }
  }, [
    dispatch,
    filterInfo,
    selectedUtility,
    filters,
    startDate,
    brokerageId,
    isEnerexStatePresent,
    basicInfo.rateCode,
    loadZoneRateCodes,
    rateClassCodes,
    portalSettings.keyValue,
    basicInfo,
  ]);

  useEffect(() => {
    dispatch(
      savePrice({
        ...basicInfo,
        utility: filters.utility,
        class: filters.class,
        commodity: filters.commodity,
      })
    );
    // eslint-disable-next-line
  }, [filters.utility, filters.class, filters.commodity, dispatch]);

  const handleUtility = (utility) => {
    dispatch(savePrice({ ...basicInfo, utility: utility }));
  };

  const pricesForComparison = searchedPrices.filter(
    (supplier) => supplier.isSelectedForPriceComparision === true
  );

  const isValidYear = (date) => new Date(date).getFullYear().toString() !== "1";

  // SORT PRICES BASED ON TERMS AND PRICE VALUES
  Array.prototype.defaultSortPrices = function (sorted) {
    if (sorted) {
      const sortedPrices = sortPricesAsPerUsage(
        getMonthlyUsage(portalSettings.keyValue, filters.usage)
      );
      const priceType =
        filters.class === CLASS.RESIDENTIAL && isEnerexStatePresentForPrice
          ? filters.commodity === COMMODITY.ELECTRIC
            ? `Price${sortedPrices[0]}kwh`
            : `Price${sortedPrices[0]}therm`
          : "Price";
      return this.sort((a, b) => {
        return a.Term - b.Term || a[priceType] - b[priceType];
      });
    }
    return this;
  };

  //FILTER OUT PRICES IN ZERO VALUES
  Array.prototype.filterPricesWithZeroValue = function () {
    const sortedPrices = sortPricesAsPerUsage(
      getMonthlyUsage(portalSettings.keyValue, filters.usage)
    );
    const priceType =
      filters.class === CLASS.RESIDENTIAL && isEnerexStatePresentForPrice
        ? filters.commodity === COMMODITY.ELECTRIC
          ? `Price${sortedPrices[0]}kwh`
          : `Price${sortedPrices[0]}therm`
        : "Price";
    return this.filter((a) => a[priceType] !== 0);
  };

  //ASSIGN OG INDEX TO MAKE COMPARISON WORK
  Array.prototype.assignOgIndex = function () {
    return this.map((searchedPrice, index) => {
      return { ...searchedPrice, ogIndex: index };
    });
  };

  //FILTER OUT PRICES BASED ON SELECTED UTILITY IN WIDGET SCREEN
  Array.prototype.getUtilityFilteredPlans = function () {
    return selectedUtilities
      ? this.filter(
          (price) =>
            price.LDCId.toLowerCase() === selectedUtilities.toLowerCase()
        )
      : this;
  };

  const supplierDetails = (supplier) =>
    supplierFields.reduce((acc, value) => {
      if (
        supplier[value.keyName] &&
        (value.type === "date" ? isValidYear(supplier[value.keyName]) : true) &&
        (value.keyName !== MARGIN || portalSettings.discloseMargin)
      )
        acc.push({
          key:
            value.keyName === "RateClass" &&
            showESIIDorECLID(basicInfo?.state?.id)
              ? LOAD_PROFILE
              : value.displayName,
          value: value.showTextWhenEnable || supplier[value.keyName],
          type: value.type || "default",
          unit: value.unit,
          unitPlace: value.unitPlace,
          shouldShowInTwoCol: value.shouldShowInTwoCol,
        });
      return acc;
    }, []);

  const sortPricesAsPerUsage = (usage) => {
    const prices = [500, 1000, 2000];
    return prices.sort((a, b) => {
      return Math.abs(usage - a) - Math.abs(usage - b);
    });
  };

  const getSuppliers = (supplierNames) => {
    const selectedSupplierIds = supplierNames.map((supplierName) => {
      const selectedSupplierId = searchedPricesSuppliers.find(
        (supplierData) => supplierData.SupplierName === supplierName
      );
      if (selectedSupplierId) return selectedSupplierId.SupplierId;
    });
    if (selectedSupplierIds.length > 0) {
      return selectedSupplierIds;
    } else if (selectedSupplierIds.length === 0) {
      return [];
    }
    return searchedPricesSuppliers.map((supplierId) => supplierId.SupplierId);
  };

  const getPricesDisplay = (supplier) => {
    const sortedPrices = sortPricesAsPerUsage(
      getMonthlyUsage(portalSettings.keyValue, filters.usage)
    );
    if (!preferedPriceDisplayFormat)
      dispatch(setPreferedPriceDisplayFormat(sortedPrices[0]));
    return (
      // <Col md="auto" lg="6">
      //   <div className="adjust-spacing">
      //     <div className="mb-2">
      //       <h4 className="heading-text mb-0">
      //         {getFormattedPrice(
      //           filters.commodity === COMMODITY.ELECTRIC
      //             ? supplier[`Price${sortedPrices[0]}kwh`]
      //             : supplier[`Price${sortedPrices[0]}therm`],
      //           supplier.PlanId
      //         ).toFixed(2)}
      //         &cent;
      //       </h4>
      //       <span className="sub-heading-text f-16 text-muted">
      //         {sortedPrices[0]}{" "}
      //         {filters.commodity === COMMODITY.ELECTRIC ? ELECTRIC : NAT_GAS}
      //       </span>
      //     </div>
      //     <div className="d-flex px-30 justify-content-center">
      //       <div className="heading-margin">
      //         <h6 className="heading-text mb-0">
      //           {getFormattedPrice(
      //             filters.commodity === COMMODITY.ELECTRIC
      //               ? supplier[`Price${sortedPrices[1]}kwh`]
      //               : supplier[`Price${sortedPrices[1]}therm`],
      //             supplier.PlanId
      //           ).toFixed(2)}
      //           &cent;
      //         </h6>
      //         <span className="sub-heading-text f-12 text-muted">
      //           {sortedPrices[1]}{" "}
      //           {filters.commodity === COMMODITY.ELECTRIC ? ELECTRIC : NAT_GAS}
      //         </span>
      //       </div>
      //       <div className="ml-3">
      //         <h6 className="heading-text mb-0">
      //           {getFormattedPrice(
      //             filters.commodity === COMMODITY.ELECTRIC
      //               ? supplier[`Price${sortedPrices[2]}kwh`]
      //               : supplier[`Price${sortedPrices[2]}therm`],
      //             supplier.PlanId
      //           ).toFixed(2)}
      //           &cent;
      //         </h6>
      //         <span className="sub-heading-text f-12 text-muted">
      //           {sortedPrices[2]}{" "}
      //           {filters.commodity === COMMODITY.ELECTRIC ? ELECTRIC : NAT_GAS}
      //         </span>
      //       </div>
      //     </div>
      //   </div>
      // </Col>
      <>
        <Col lg={1}></Col>
        <Col md="12" lg={3}>
          <div className="adjust-spacing-prices">
            <div>
              <Row>
                <Col lg={12} className="mt-3">
                  <div className="mb-2">
                    <h4 className="heading-text mb-0">
                      {getFormattedPrice(
                        filters.commodity === COMMODITY.ELECTRIC
                          ? supplier[`Price${sortedPrices[0]}kwh`]
                          : supplier[`Price${sortedPrices[0]}therm`],
                        supplier.PlanId
                      ).toFixed(2)}
                      &cent;
                    </h4>
                    <span className="sub-heading-text f-16 text-muted">
                      {sortedPrices[0]}{" "}
                      {filters.commodity === COMMODITY.ELECTRIC
                        ? ELECTRIC
                        : supplier.UOM
                        ? supplier.UOM
                        : NAT_GAS}
                    </span>
                  </div>
                </Col>
                <Col lg={12} className="mt-3">
                  <Row>
                    <Col>
                      <div className="heading-margin">
                        <h6 className="heading-text mb-0">
                          {getFormattedPrice(
                            filters.commodity === COMMODITY.ELECTRIC
                              ? supplier[`Price${sortedPrices[1]}kwh`]
                              : supplier[`Price${sortedPrices[1]}therm`],
                            supplier.PlanId
                          ).toFixed(2)}
                          &cent;
                        </h6>
                        <span className="sub-heading-text f-12 text-muted">
                          {sortedPrices[1]}{" "}
                          {filters.commodity === COMMODITY.ELECTRIC
                            ? ELECTRIC
                            : supplier.UOM
                            ? supplier.UOM
                            : NAT_GAS}
                        </span>
                      </div>
                    </Col>
                    <Col>
                      <div className="ml-3">
                        <h6 className="heading-text mb-0">
                          {getFormattedPrice(
                            filters.commodity === COMMODITY.ELECTRIC
                              ? supplier[`Price${sortedPrices[2]}kwh`]
                              : supplier[`Price${sortedPrices[2]}therm`],
                            supplier.PlanId
                          ).toFixed(2)}
                          &cent;
                        </h6>
                        <span className="sub-heading-text f-12 text-muted">
                          {sortedPrices[2]}{" "}
                          {filters.commodity === COMMODITY.ELECTRIC
                            ? ELECTRIC
                            : supplier.UOM
                            ? supplier.UOM
                            : NAT_GAS}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col lg={2}></Col>
      </>
    );
  };
  const supplierPresent = (supplier) => {
    return selectedSuppliers.find(
      (selectedSupplier) => selectedSupplier === supplier
    );
  };

  useEffect(() => {
    ctx.set(filters.month);
  }, [filters.month]);
  console.log(filterInfo);

  return (
    <main className={classNames("inner-widget", { "px-20": !isFullScreen })}>
      <Card className={classNames("shadow-lg", { "min-h-100": isFullScreen })}>
        <Card.Header className="p-header">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="f-15 mb-0">Show Prices</h5>
            <div className="d-flex align-items-center">
              {portalSettings.phoneWork && (
                <h6 className="sub-heading-text f-14 text-muted">
                  Need Assistance?: Call {portalSettings.phoneWork}
                </h6>
              )}
              <ContactMeButton parent="ShowPrices" />
              <Button
                variant="outline-light"
                onClick={() =>
                  handleCloseWidget(dispatch, history, clientConfig.client)
                }
              >
                <i className="fa fa-times fa-2x f-20"></i>
              </Button>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          {tier === TIERS.MID && (
            <Button
              variant="outline-primary"
              className="mb-3"
              onClick={() => {
                history.push("select-pricing");
              }}
            >
              Back
            </Button>
          )}
          <div className="card border bg-light mb-3">
            <Card.Body className="p-3">
              {filters.class === CLASS.COMMERCIAL && (
                <>
                  <Row className="mx-n1 mb-1">
                    <Col
                      xl={3}
                      lg={3}
                      md={8}
                      className="d-flex px-1 mb-3 mb-lg-0 gen-ecaafdbe"
                    >
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          setFilterInfo({
                            ...filterInfo,
                            month: e.target.value,
                            isFilterUpdated: true,
                          });
                          ctx.set(e.target.value);
                        }}
                        value={filterInfo.month}
                      >
                        {monthsOptions.map((each, index) => (
                          <option value={each.month} key={index}>
                            {each.month}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control
                        as="select"
                        className="f-14 ml-8"
                        onChange={(e) => {
                          const updatedMonth = selectedMonths.filter(
                            (each) => each.year === Number(e.target.value)
                          )[0].month;
                          setFilterInfo({
                            ...filterInfo,
                            month: updatedMonth,
                            year: e.target.value,
                            isFilterUpdated: true,
                          });
                        }}
                        value={filterInfo.year}
                      >
                        {selectedYears.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xl={3} lg={5} md={8} className="px-1 mb-3 mb-lg-0">
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          const utility = JSON.parse(e.target.value);
                          dispatch(
                            setIsSupplierUpdated(
                              JSON.stringify(utility) !==
                                JSON.stringify(filters.utility) &&
                                filters.class === CLASS.RESIDENTIAL
                            )
                          );
                          dispatch(
                            getRateCodes({
                              filters: {
                                LDCIdentifiers:
                                  filters.class === CLASS.COMMERCIAL
                                    ? [utility.LDCIdentifier]
                                    : [],
                                Commodity:
                                  COMMODITIES_LIST[filterInfo.commodity],
                                StateId: basicInfo.state.id,
                                StateName: basicInfo.state.name,
                                ZipCode: localZipCode,
                                BrokerId: brokerageId,
                                RateClassification: filterInfo.class,
                              },
                            })
                          ).then(() => {
                            setFilterInfo({
                              ...filterInfo,
                              utility,
                              isFilterUpdated: true,
                            });
                          });
                          handleUtility(e.target.value);
                        }}
                        value={JSON.stringify(
                          utilities.length === 1
                            ? utilities[0]
                            : filterInfo.utility
                        )}
                      >
                        {utilities.length === 1 && (
                          <option value={JSON.stringify(utilities[0].LDCName)}>
                            {utilities[0].LDCName}
                          </option>
                        )}
                        {info.class === CLASS.RESIDENTIAL &&
                          utilities.length !== 1 && (
                            <option value={JSON.stringify({})}>
                              Select Utility
                            </option>
                          )}
                        {utilities.length !== 1 &&
                          utilities.map((utilityItem, index) => (
                            <option
                              key={index}
                              value={JSON.stringify(utilityItem)}
                            >
                              {utilityItem.LDCName}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                    <Col
                      xl={3}
                      lg={3}
                      md={4}
                      className="px-1 mb-3 mb-md-0 mb-xl-0"
                    >
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          if (e.target.value === "Sort by: Select an option") {
                            setSorted(true);
                          } else {
                            setSorted(false);
                            const selectedSorting = SORTING_ORDERS.find(
                              (sortingOrder) =>
                                sortingOrder.id === Number(e.target.value)
                            );
                            setFilterInfo({
                              ...filterInfo,
                              order: selectedSorting.order,
                              sort:
                                selectedSorting.value === "Price" &&
                                preferedPriceDisplayFormat &&
                                info.class === CLASS.RESIDENTIAL
                                  ? filters.commodity === COMMODITY.ELECTRIC
                                    ? `Price${preferedPriceDisplayFormat}kwh`
                                    : `Price${preferedPriceDisplayFormat}therm`
                                  : selectedSorting.value,
                              isFilterUpdated: true,
                            });
                          }
                        }}
                      >
                        <option>{`Sort by: Select an option`}</option>
                        {SORTING_ORDERS.map((each) => (
                          <option key={each.id} value={each.id}>
                            {`Sort by ${each.name}`}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xl={3} lg={3} md={4} className="btn-px">
                      {pricesForComparison.length >= 1 ? (
                        <Button
                          variant="info"
                          className="f-14 btn-block"
                          onClick={() => {
                            if (pricesForComparison.length === 1)
                              setIsOnePriceSelected(true);
                            else {
                              analytics.sendEventWithData("Compare Prices", {
                                pricesForComparison:
                                  JSON.stringify(pricesForComparison),
                              });
                              history.push("/price-selection");
                            }
                          }}
                        >
                          <i className="fa fa-heart mr-2"></i>Compare
                        </Button>
                      ) : (
                        <Overlay content="Select energy plans to compare.">
                          <span>
                            <Button
                              variant="info"
                              className="f-14 btn-block"
                              style={{ pointerEvents: "none" }}
                              disabled={true}
                            >
                              <i className="fa fa-heart mr-2"></i>Compare
                            </Button>
                          </span>
                        </Overlay>
                      )}
                    </Col>
                  </Row>
                </>
              )}
              {filters.class === CLASS.RESIDENTIAL && (
                <>
                  <Row className="mx-n1 mb-1">
                    <Col xl={3} lg={6} md={8} className="px-1 mb-3 mb-lg-3">
                      <div className="d-flex align-items-center">
                        <span className="f-14 mr-2 text-nowrap">
                          Contract Length
                        </span>
                        <NumberFormat
                          type="text"
                          className="f-14 form-control"
                          onChange={(e) =>
                            setFilterInfo({
                              ...filterInfo,
                              from: e.target.value,
                            })
                          }
                          onBlur={() => {
                            const formattedValue =
                              parseInt(filterInfo.to) >=
                                parseInt(filterInfo.from) || !filterInfo.to
                                ? filterInfo.from
                                : "";
                            if (formattedValue) {
                              setFilterInfo({
                                ...filterInfo,
                                from: formattedValue,
                                isFilterUpdated: true,
                              });
                            }
                          }}
                          value={filterInfo.from}
                          allowNegative={false}
                        />
                        <span className="f-14 px-1">To</span>
                        <NumberFormat
                          type="text"
                          className="f-14 form-control"
                          onChange={(e) =>
                            setFilterInfo({
                              ...filterInfo,
                              to: e.target.value,
                            })
                          }
                          onBlur={() => {
                            const formattedValue =
                              parseInt(filterInfo.to) >=
                                parseInt(filterInfo.from) || !filterInfo.from
                                ? filterInfo.to
                                : "";
                            if (formattedValue) {
                              setFilterInfo({
                                ...filterInfo,
                                to: formattedValue,
                                isFilterUpdated: true,
                              });
                            }
                          }}
                          value={filterInfo.to}
                          allowNegative={false}
                        />
                        <span className="f-14 px-1">Months</span>
                      </div>
                    </Col>
                    <Col
                      xl={2}
                      lg={3}
                      md={4}
                      className="px-1 mb-3 mb-lg-3 mt-lg-0"
                    >
                      <Form.Control
                        as="select"
                        className="f-14"
                        value={SELECT_SUPPLIERS}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (selectedSuppliers.length === 0) {
                            let suppliers = [...selectedSuppliers, value];
                            setSelectedSuppliers(suppliers);
                            setFilterInfo({
                              ...filterInfo,
                              supplier: value,
                              Suppliers: getSuppliers(suppliers),
                            });
                          } else {
                            let suppliers = selectedSuppliers.filter(
                              (supplier) => !(supplier === value)
                            );
                            if (suppliers.length !== selectedSuppliers.length) {
                              setSelectedSuppliers(suppliers);
                              setFilterInfo({
                                ...filterInfo,
                                supplier: value,
                                Suppliers: getSuppliers(suppliers),
                              });
                            } else {
                              setSelectedSuppliers([
                                ...new Set([
                                  e.target.value,
                                  ...selectedSuppliers,
                                ]),
                              ]);
                              setFilterInfo({
                                ...filterInfo,
                                supplier: value,
                                Suppliers: getSuppliers([
                                  ...new Set([
                                    e.target.value,
                                    ...selectedSuppliers,
                                  ]),
                                ]),
                              });
                            }
                          }
                        }}
                        onBlur={(e) => {
                          setFilterInfo({
                            ...filterInfo,
                            isFilterUpdated: true,
                          });
                        }}
                      >
                        {/* {searchedPricesSuppliers.length === 1 && (
                          <option
                            value={searchedPricesSuppliers[0].SupplierName}
                          >
                            {searchedPricesSuppliers[0].SupplierName}
                          </option>
                        )}
                        {searchedPricesSuppliers.length !== 1 && (
                          <option value={ALL_SUPPLIERS}>All Suppliers</option>
                        )}
                        {searchedPricesSuppliers.length !== 1 &&
                          searchedPricesSuppliers.map((supplier, index) => (
                            <option key={index} value={supplier.SupplierName}>
                              {supplier.SupplierName}
                            </option>
                          ))} */}
                        {evaluateSupplierPlaceholder()}
                        {searchedPricesSuppliers.map((supplier, index) => (
                          <option
                            className={
                              supplierPresent(supplier.SupplierName)
                                ? "selectedOption"
                                : "unselectedOption"
                            }
                            key={index}
                            value={supplier.SupplierName}
                          >
                            {supplier.SupplierName}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xl={2} lg={3} md={8} className="px-1 mb-3 mb-lg-3">
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          if (selectedUtilities)
                            dispatch(setSelectedUtilities(""));
                          const utility = JSON.parse(e.target.value);
                          dispatch(
                            getRateCodes({
                              filters: {
                                LDCIdentifiers:
                                  filters.class === CLASS.COMMERCIAL
                                    ? [utility.LDCIdentifier]
                                    : [],
                                Commodity:
                                  COMMODITIES_LIST[filterInfo.commodity],
                                StateId: basicInfo.state.id,
                                StateName: basicInfo.state.name,
                                ZipCode: localZipCode,
                                BrokerId: brokerageId,
                                RateClassification: filterInfo.class,
                              },
                            })
                          ).then(() => {
                            setFilterInfo({
                              ...filterInfo,
                              utility,
                              isFilterUpdated: true,
                            });
                          });
                          handleUtility(e.target.value);
                        }}
                        value={JSON.stringify(
                          selectedUtilities
                            ? utilities.find(
                                (utility) => utility.LDCId === selectedUtilities
                              )
                            : utilities.length === 1
                            ? utilities[0]
                            : filterInfo.utility
                        )}
                      >
                        {utilities.length === 1 && (
                          <option value={JSON.stringify(utilities[0].LDCName)}>
                            {utilities[0].LDCName}
                          </option>
                        )}
                        {info.class === CLASS.RESIDENTIAL &&
                          utilities.length !== 1 && (
                            <option value={JSON.stringify({})}>
                              Select Utility
                            </option>
                          )}
                        {utilities.length !== 1 &&
                          utilities.map((utilityItem, index) => (
                            <option
                              key={index}
                              value={JSON.stringify(utilityItem)}
                            >
                              {utilityItem.LDCName}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                    <Col
                      xl={2}
                      lg={4}
                      md={4}
                      className="px-1 mb-3 mb-md-0 mb-xl-0"
                    >
                      <Form.Control
                        as="select"
                        className="f-14"
                        onChange={(e) => {
                          if (e.target.value === "Sort by: Select an option") {
                            setSorted(true);
                          } else {
                            setSorted(false);
                            const selectedSorting = SORTING_ORDERS.find(
                              (sortingOrder) =>
                                sortingOrder.id === Number(e.target.value)
                            );
                            setFilterInfo({
                              ...filterInfo,
                              order: selectedSorting.order,
                              sort:
                                selectedSorting.value === "Price" &&
                                preferedPriceDisplayFormat &&
                                info.class === CLASS.RESIDENTIAL
                                  ? filters.commodity === COMMODITY.ELECTRIC
                                    ? `Price${preferedPriceDisplayFormat}kwh`
                                    : `Price${preferedPriceDisplayFormat}therm`
                                  : selectedSorting.value,
                              isFilterUpdated: true,
                            });
                          }
                        }}
                      >
                        <option>{`Sort by: Select an option`}</option>
                        {SORTING_ORDERS.map((each) => (
                          <option key={each.id} value={each.id}>
                            {`Sort by ${each.name}`}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xl={1} lg={4} md={8} className="px-1 mb-3 mb-lg-0">
                      <NumberFormat
                        type="text"
                        allowLeadingZeros={true}
                        placeholder="Zip Code"
                        className="f-14 form-control"
                        value={filterInfo.zipCode || localZipCode}
                        onBlur={(e) => {
                          setSelectedSuppliers([]);
                          dispatch(getStateFromZip({ zipcode: localZipCode }));
                          if (e.target.value && e.target.value.length == 5) {
                            dispatch(
                              setSupplierPricesTriggeredFromGetPrices(true)
                            );
                            dispatch(setIsSupplierUpdated(true));
                            setFilterInfo({
                              ...filterInfo,
                              zipCode: e.target.value,
                              Suppliers: getSuppliers([]),
                              utility: [],
                              isFilterUpdated: true,
                            });
                          }
                        }}
                        onChange={(e) => {
                          setLocalZipCode(e.target.value);
                          setFilterInfo({
                            ...filterInfo,
                            zipCode: e.target.value,
                          });
                        }}
                        allowNegative={false}
                        maxLength={100}
                      />
                      {localZipCode && localZipCode.length < 5 && (
                        <div className="error-message mt-1">
                          Zip Code must contain at least 5 digits.
                        </div>
                      )}
                      {localZipCode && localZipCode.length > 5 && (
                        <div className="error-message mt-1">
                          Invalid Zipcode.
                        </div>
                      )}
                    </Col>
                    <Col xl={2} lg={4} md={4} className="btn-px">
                      {pricesForComparison.length >= 1 ? (
                        <Button
                          variant="info"
                          className="f-14 btn-block"
                          onClick={() => {
                            if (pricesForComparison.length === 1)
                              setIsOnePriceSelected(true);
                            else {
                              analytics.sendEventWithData("Compare Prices", {
                                pricesForComparison:
                                  JSON.stringify(pricesForComparison),
                              });
                              history.push("/price-selection");
                            }
                          }}
                        >
                          <i className="fa fa-heart mr-2"></i>Compare
                        </Button>
                      ) : (
                        <Overlay content="Select energy plans to compare.">
                          <span>
                            <Button
                              variant="info"
                              className="f-14 btn-block"
                              style={{ pointerEvents: "none" }}
                              disabled={true}
                            >
                              <i className="fa fa-heart mr-2"></i>Compare
                            </Button>
                          </span>
                        </Overlay>
                      )}
                    </Col>
                  </Row>
                </>
              )}
              {isOnePriceSelected && (
                <Row>
                  <Col md={4} lg={4}>
                    <div></div>
                  </Col>
                  <Col md={6} lg={6}>
                    <Form.Label>
                      You have only selected one option, would you like to go
                      straight to the Selected Rate page?
                    </Form.Label>
                  </Col>
                  <Col md={2} lg={2}>
                    <Button
                      variant="outline-primary"
                      className="f-14 btn-block mb-2"
                      onClick={() => {
                        setIsOnePriceSelected(false);
                        suppliersToBeCompared[0].PlanId
                          ? dispatch(setSteps(stepsForEnrollmentandPlanId))
                          : dispatch(setSteps(updatedStepsForFalseEnrollment));
                        dispatch(setShouldShowRFQDetails(false));
                        dispatch(setIsPriceExpired(false));
                        dispatch(
                          setSelectedSupplier({
                            ...suppliersToBeCompared[0],
                            supplierLogo:
                              suppliersLogo[
                                suppliersToBeCompared[0].SupplierId
                              ],
                            supplierDetails: supplierDetails(
                              suppliersToBeCompared[0]
                            ),
                          })
                        );
                        history.push("info");
                        portalSettings.discloseMargin &&
                          dispatch(
                            getApplicableMargin({
                              supplierId: suppliersToBeCompared[0].SupplierId,
                              stateId: basicInfo.state.id,
                              commodity: filters.commodity,
                              utilityId: suppliersToBeCompared[0].LDCId,
                              rateClass: suppliersToBeCompared[0].RateClass,
                              brokerageId,
                            })
                          );
                      }}
                    >
                      Yes
                    </Button>
                  </Col>
                </Row>
              )}
              <ShowMoreFilters
                filterInfo={filterInfo}
                setFilterInfo={setFilterInfo}
                setInfo={setInfo}
                setLocalZipCode={setLocalZipCode}
                info={info}
                handleUtility={handleUtility}
                utilities={utilities}
                localZipCode={localZipCode}
                suppliers={searchedPricesSuppliers}
                searchedPrices={searchedPrices}
                initialSupplierData={initialSupplierData}
                brokerageId={brokerageId}
                filters={filters}
                setIsSupplierUpdated={setIsSupplierUpdated}
                setShowUtilityError={setShowUtilityError}
              />
            </Card.Body>
          </div>
          {isPriceExpired && showPriceExpiredAlert && opportunityId && (
            <Alert
              variant="danger"
              dismissible
              onClose={() => setShowPriceExpiredAlert(false)}
            >
              <p>Price Expired. Please Select New.</p>
            </Alert>
          )}
          {(searchedPrices.length === 0 && show) || showUtilityError ? (
            <BusyIndicator region={REGIONS.GET_SUPPLIERS}>
              <Alert
                variant="danger"
                onClose={() => {
                  setShow(false);
                  setShowUtilityError(false);
                }}
              >
                <p>
                  {showUtilityError
                    ? `We're sorry, but there are no ${
                        COMMODITIES_LIST[filters.commodity]
                      } options for your zipcode. Check back later!`
                    : messageOnEmptyResult ||
                      DEFALUT_NO_SUPPLIER_LOADED_MESSAGE}
                </p>
                <Button
                  onClick={() => {
                    history.push("contact-me");
                  }}
                  className="wizard-footer d-flex ml-auto "
                >
                  Contact Me
                </Button>
              </Alert>
            </BusyIndicator>
          ) : (
            <BusyIndicator region={REGIONS.GET_SUPPLIERS}>
              <div
                className={classNames("card-responsive", {
                  fullscreen: isFullScreen,
                })}
              >
                {searchedPrices
                  .assignOgIndex()
                  .defaultSortPrices(sorted)
                  .getUtilityFilteredPlans()
                  .filterPricesWithZeroValue()
                  .map((supplier, index) => {
                    const supplierLogo = supplier.logo && supplier.logo.toLowerCase() !== supplier.SupplierId.toLowerCase() ? suppliersLogo[supplier.logo] : suppliersLogo[supplier.SupplierId]; 
                    return (
                      (productType === ALL_PRODUCT ||
                        supplier.ProductType === productType) && (
                        <div
                          className="d-flex align-items-center mb-3 position-relative"
                          key={index}
                        >
                          <Button
                            variant="link"
                            className="text-dark f-32 align-btn"
                            onClick={() => {
                              setIsOnePriceSelected(false);
                              dispatch(
                                setPriceForComparision({
                                  selectedPriceIndex: Number.isInteger(
                                    supplier.ogIndex
                                  )
                                    ? supplier.ogIndex
                                    : index,
                                  supplierDetails: supplierDetails(supplier),
                                })
                              );
                            }}
                          >
                            <i
                              className={classNames("fa fa-heart", {
                                "fa-heart-o":
                                  !supplier.isSelectedForPriceComparision,
                              })}
                            ></i>
                          </Button>
                          <div className="card border flex-fill">
                            <Card.Body className="p-card">
                              <Row className="mt-4">
                                <Col md={2} className="mb-2">
                                  {supplierLogo && (
                                    <div
                                      className="supplier-logo mr-5 mt-4"
                                      style={{
                                        verticalAlign: "top",
                                        display: "inline-block",
                                        textAlign: "center",
                                        width: "160px",
                                        height: "90px",
                                      }}
                                    >
                                      <Image
                                        src={supplierLogo}
                                        width="110em"
                                        height="55em"
                                        alt=""
                                      ></Image>
                                      {isEnerexStatePresent &&
                                        supplier.PUCT && (
                                          <div style={{ display: "block" }}>
                                            <h6 className="f-14 text-muted">
                                              PUCT# {supplier.PUCT}
                                            </h6>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                  {!supplierLogo && (
                                    <div
                                      style={{
                                        verticalAlign: "top",
                                        display: "inline-block",
                                        textAlign: "center",
                                      }}
                                    >
                                      <span className="sub-heading-text f-14 text-muted ml-20">
                                        {supplier.SupplierName}
                                      </span>
                                      {isEnerexStatePresent &&
                                        supplier.PUCT && (
                                          <div style={{ display: "block" }}>
                                            <h6 className="sub-heading-text f-14 text-muted">
                                              PUCT# {supplier.PUCT}
                                            </h6>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </Col>
                                <Col
                                  md={8}
                                  className="text-center mb-3 mb-md-0"
                                >
                                  <Row>
                                    <Col md={12} lg="6">
                                      <Row className="mt-4">
                                        {supplier.ProductType &&
                                          supplier.ProductType !== "" && (
                                            <Col className="adjust-spacing-column-wise">
                                              <h4 className="heading-text">
                                                {supplier.ProductType}
                                              </h4>
                                              <span className="sub-heading-text-center f-14 text-muted">
                                                Product
                                              </span>
                                            </Col>
                                          )}
                                        {supplier.PlanName &&
                                          supplier.PlanName !== "" && (
                                            <Col className="adjust-spacing-column-wise">
                                              <h4 className="heading-text">
                                                {supplier.PlanName}
                                              </h4>
                                              <span className="sub-heading-text-center f-14 text-muted">
                                                Plan Name
                                              </span>
                                            </Col>
                                          )}
                                        {supplier.Term &&
                                          supplier.Term !== "" && (
                                            <Col className="adjust-spacing-column-wise">
                                              <h4 className="heading-text">
                                                {supplier.Term}
                                                <span> Months</span>
                                              </h4>
                                              <span className="sub-heading-text-center f-14 text-muted">
                                                Term
                                              </span>
                                            </Col>
                                          )}
                                      </Row>
                                    </Col>

                                    {filters.class === CLASS.RESIDENTIAL &&
                                      supplier.PlanId &&
                                      isEnerexStatePresentForPrice &&
                                      getPricesDisplay(supplier)}
                                    {supplier.Price &&
                                      !(
                                        filters.class === CLASS.RESIDENTIAL &&
                                        supplier.PlanId &&
                                        isEnerexStatePresentForPrice
                                      ) && (
                                        <Col className="adjust-spacing-column-wise mt-4">
                                          <h4 className="heading-text mt-2">
                                            {getFormattedPrice(
                                              supplier.Price,
                                              supplier.PlanId
                                            ).toFixed(2)}
                                            &cent;/
                                            {filters.commodity ===
                                            COMMODITY.ELECTRIC
                                              ? ELECTRIC
                                              : supplier.UOM
                                              ? supplier.UOM
                                              : NAT_GAS}
                                          </h4>
                                          <span className="sub-heading-text-center f-14 text-muted">
                                            Price
                                          </span>
                                        </Col>
                                      )}
                                  </Row>
                                </Col>
                                <Col
                                  md={2}
                                  className="justify-content-center align-items-center"
                                >
                                  <Button
                                    variant="outline-primary"
                                    className="mt-4 btn-block select-button"
                                    onClick={() => {
                                      supplier.PlanId
                                        ? dispatch(
                                            setSteps(
                                              stepsForEnrollmentandPlanId
                                            )
                                          )
                                        : dispatch(
                                            setSteps(
                                              updatedStepsForFalseEnrollment
                                            )
                                          );
                                      dispatch(setShouldShowRFQDetails(false));
                                      dispatch(setIsPriceExpired(false));
                                      dispatch(
                                        setSelectedSupplier({
                                          ...supplier,
                                          supplierLogo,
                                          supplierDetails:
                                            supplierDetails(supplier),
                                        })
                                      );
                                      dispatch(
                                        getSuppierAddressFields({
                                          brokerageId: brokerageId,
                                          supplierId: supplier.SupplierId,
                                          subscriptionKey: authKey,
                                        })
                                      );
                                      dispatch(
                                        getAcountPattern({
                                          utilityId: supplier.LDCId,
                                          stateId: basicInfo.state.id,
                                          commodity: filters.commodity,
                                        })
                                      );
                                      history.push("info");
                                      portalSettings.discloseMargin &&
                                        dispatch(
                                          getApplicableMargin({
                                            supplierId: supplier.SupplierId,
                                            stateId: basicInfo.state.id,
                                            commodity: filters.commodity,
                                            utilityId: supplier.LDCId,
                                            rateClass: supplier.RateClass,
                                            brokerageId,
                                          })
                                        );
                                      analytics.sendEventWithData(
                                        "Select Price",
                                        supplier
                                      );
                                    }}
                                  >
                                    Select
                                  </Button>
                                  <Button
                                    variant="link"
                                    className={`f-14 d-block text-center btn-block view-more-button accordion_button`}
                                    onClick={() => {
                                      setCardDetails(!cardDetails);
                                      let accordianArr = [...chosenAccordian];
                                      if (accordianArr.includes(index)) {
                                        accordianArr = accordianArr.filter(
                                          (val) => !(val === index)
                                        );
                                      } else {
                                        accordianArr.push(index);
                                      }
                                      setChosenAccordian(accordianArr);
                                    }}
                                  >
                                    {chosenAccordian.includes(index)
                                      ? "Less"
                                      : "More"}{" "}
                                    Details
                                    <i
                                      className={classNames(
                                        "fa fa-chevron-up ml-2",
                                        {
                                          "fa-chevron-down":
                                            !chosenAccordian.includes(index),
                                        }
                                      )}
                                    />
                                  </Button>
                                </Col>
                              </Row>
                              {/* Show price details here we can pass desription of the details as a props to the ShowPriceDetails Component */}
                              <ShowPriceDetails
                                supplier={supplier}
                                supplierDetails={supplierDetails(supplier)}
                                cardDetails={chosenAccordian.includes(index)}
                              />
                            </Card.Body>
                          </div>
                        </div>
                      )
                    );
                  })}
              </div>
            </BusyIndicator>
          )}
        </Card.Body>
      </Card>
    </main>
  );
};

export default ShowPrices;
